import { Node, mergeAttributes } from "@tiptap/core";

export interface SectionTitleAttributes {
  content: string;
  sectionKey: string;
}

export const SectionTitleNode = Node.create({
  name: "sectionTitle",
  group: "block",
  content: "inline*",
  draggable: true,

  addAttributes() {
    return {
      content: {
        type: "string",
        default: "Title",
      },
      sectionKey: {
        type: "string",
        default: "",
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "div.non-editable-section-title",
        getAttrs: (node) => {
          if (!(node instanceof HTMLElement)) return false;
          return {
            content: node.textContent,
            sectionKey: node.getAttribute("data-section-key"),
          };
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      mergeAttributes(
        {
          class: "non-editable-section-title",
          "data-section-key": HTMLAttributes.sectionKey,
        },
        HTMLAttributes,
      ),
      HTMLAttributes.content || "Title",
    ];
  },
});